export const defaults = {
    typography: {
        fontFamily: "var(--font-poppins), Arial, sans-serif",
        h5: {
            fontWeight: 600,
            fontSize: 30,
            letterSpacing: 0,
        },
        h6: {
            fontWeight: 700,
            fontSize: 24,
            letterSpacing: 0,
        },
        h7: {
            fontWeight: 700,
            fontSize: 20,
            letterSpacing: 0.15,
        },
        h8: {
            fontWeight: 700,
            fontSize: 18,
            letterSpacing: 0.15,
        },
        body1Medium: {
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: 0.15,
        },
        body2: {
            fontSize: 14,
            letterSpacing: 0.17,
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: 16,
            letterSpacing: 0.15,
        },
        button: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: 0.4,
        },
        caption: {
            fontSize: 12,
            fontWeight: 400,
            letterSpacing: 0.6,
        },
    },
    palette: {
        primary: {
            main: "#002C5F",
        },
        secondary: {
            main: "#00AAD2",
        },
        background: {
            default: "#f2f2f2",
            paper: "#ffffff",
        },
        text: {
            primary: "#1C1B1B",
            secondary: "#666666",
        },
        DataGrid: {
            bg: "#fff",
            pinnedBg: "#fff",
            headerBg: "#fff",
        },
    },
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    "&:hover": {
                        backgroundColor: "#001E420A !important",
                    },
                    "& + .MuiAutocomplete-option[aria-selected='true']": {
                        backgroundColor: "#fff",
                    },
                },
            },
            defaultProps: {
                slotProps: {
                    paper: {
                        elevation: 5,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #fff inset",
                        WebkitTextFillColor: "ffffff",
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        backgroundColor: "#001E420A",
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    marginBottom: 0,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                contained: {
                    borderRadius: 0,
                    textTransform: "none",
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 8,
                    paddingBottom: 8,
                    height: 36,
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                sx: {
                    backgroundColor: "#616161E5",
                    color: "#fff",
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: "1px solid rgba(0,0,0,.12)",
                    borderRadius: 20,
                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                    },
                    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                        outline: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        // Forced to use important since overriding inline styles
                        height: "unset !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        // Forced to use important since overriding inline styles
                        maxHeight: "168px !important",
                    },
                },
                toolbar: {
                    justifyContent: "space-between",
                    flexDirection: "row-reverse",
                    padding: 20,
                    paddingTop: 13,
                    paddingBottom: 0,
                    borderBottom: "none",
                    gap: "16px",
                },
                toolbarContainer: {
                    padding: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                },
                columnHeader: {
                    "&.Mui-focusVisible": {
                        outline: "none !important",
                    },
                    height: 80,
                },
                menuIconButton: {
                    display: "none",
                },
                columnHeaderTitle: {
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: "24px",
                    letterSpacing: 0.17,
                    textAlign: "center",
                    color: "#1C1B1B !important",
                    backgroundColor: "#fff !important",
                },
                iconButtonContainer: {
                    backgroundColor: "#fff !important",
                },
                columnHeaderTitleContainer: {
                    gap: "8px",
                },
                columnSeparator: {
                    display: "none",
                },
                row: {
                    cursor: "pointer",
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: "16px",
                    "&.MuiPaper-root": {
                        border: "1px solid #dee2e6",
                    },
                    backgroundColor: "white",
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: "var(--font-poppins), Arial, sans-serif",
                },
            },
        },
        MuiChartsLegend: {
            styleOverrides: {
                root: {
                    justifyContent: "center",
                    margin: "auto",
                    fontWeight: "bold",
                    maxWidth: 600,
                },
            },
        },
    },
} as const;
